import { Form, InputNumber, Spin } from "antd";
import React, { useRef, useState } from "react";
import toast from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import { useNavigate } from "react-router-dom";
import mpesa from "../../assets/svg/mpesa.jpeg";
import ndovu from "../../assets/svg/ndovu.svg";

import WithdrawalOtpModal from "./modal/WithdrawalOtpModal"; 
import { useDispatch, useSelector } from "react-redux"; 
import InsideHeader from "../../components/InsideHeader";
import { save } from "../../features/save/saveSlice";

function PaymentPage() {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch =  useDispatch();

  const {saving} =  useSelector((state)=>state.save)

  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };

  const [formData, setFormData] = useState();
  const onChangeOther = (value, fieldName) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const handleCancel = async() => {
    await form.resetFields();
   await navigate("/ndovu-pay"); 
  };
  const handleNumberChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      withDrawPhoneNumber: String(e),
    }));
  };
  
  const onFinish = async (data) => {
    const res =  await dispatch(save({
      url:`py/TopUpWallet.action?phoneNumber=${data?.phoneNumber}&amount=${data?.amount}`
    })) 
    if (res?.payload?.success) {
      await toast.success(res?.payload?.jsonData1?.messages?.message ?? "Complete payment on your phone");  
    } else {
      toast.error(res?.payload?.jsonData?.messages?.message ?? "error sending STK push");
    }
  };
  return (
    <div className="w-full overflow-y-scroll h-full">
      <InsideHeader
        title="Wallet"
        subtitle="Top up your wallet here"
        back={true} 
        title1="Wallet"
        title2="Top up wallet"
      /> 
      <div className="lg:p-10 p-3 bg-white mt-[1.25rem] rounded-[10px]">
      <Form
        layout="vertical"
        ref={formRef}
        name="control-ref"
        onFinish={onFinish}
        className="lg:w-[700px] w-full lg:mt-0 mt-2"
        style={{
          maxWidth: "100%",
        }}
        form={form}
      >
        <Form.Item
          label="Amount"
           name="amount"
          rules={[
            {
              required: true,
              message: "Enter amount",
            },
          ]}
        >
          <InputNumber  
            min={0}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value?.replace(/\$\s?|(,*)/g, "")} 
            placeholder="Enter amount to top up"
            className="input flex"
          />
        </Form.Item>

        <Form.Item label="Pay to">
          <div>
            <img src={ndovu} loading="lazy" alt="ndovu" className="w-[100px] h-full"/>
          </div>
        </Form.Item>
        <Form.Item
          label="Enter mpesa number"
              name="phoneNumber"
          rules={[
            {
              required: true,
              message: "Enter mpesa number",
            },
          ]}
        >
          <PhoneInput  
            country="ke"
            onlyCountries={["ke"]}
            countryCodeEditable={false}
            className="input rounded-[6px] border !border-[#cacaca] !h-[42px]"
          />
        </Form.Item>
        <div className="flex justify-between mt-[60px] mb-[48px] items-center">  
        <div className="w-[150px]">
            <button
              key="back"
              type="button"
              onClick={handleCancel}
              className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
            >
              Cancel
            </button>
            </div>

            <div className="w-[150px]">
              <button
              disabled={saving}
               key="submit" type="submit" className="cstm-btn">
              {saving ? <Spin/> : 'Submit'}   
              </button>
            </div> 
        </div>
      </Form>
      </div>
 
    <WithdrawalOtpModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
  </div>
  );
}

export default PaymentPage;
